import baseIsMap from "./component-library459.mjs";
import baseUnary from "./component-library423.mjs";
import nodeUtil from "./component-library424.mjs";
var nodeIsMap = nodeUtil && nodeUtil.isMap;
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
const isMap$1 = isMap;
export {
  isMap$1 as default
};
